/**
 * APP-194: the "unlocked" bell notice says what opened the space or section.
 * The API sends `data.source` ('badge' or 'level') on `spaces.unlocked`; older
 * notices have no source and all came from a badge, so anything that is not
 * 'level' reads as a badge.
 */
export type UnlockKind = 'space' | 'section'

export const unlockSource = (data: unknown): 'badge' | 'level' =>
  (data as { source?: unknown } | null | undefined)?.source === 'level' ? 'level' : 'badge'

/** i18n key (namespace `notifications`) for an unlocked space or section. */
export const unlockedMessageKey = (kind: UnlockKind, data: unknown): string => {
  const source = unlockSource(data) === 'level' ? 'Level' : 'Badge'
  return `types.${kind}UnlockedBy${source}`
}
